import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const contentStyle = {
  position: 'fixed' as 'fixed',
  width: '60vw',
  minHeight: '80vh',
  height: 'auto',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  display: 'flex',
  p: '1rem'
};

const title = {
  py: '1rem'
};

const paragraph = {
  py: '0.5rem'
};

export const TopicModal = ({ isOpen, onClose }: ModalProps) => {
  return (
    <div>
      <Modal
        open={isOpen}
        onClose={onClose}
        aria-labelledby='subtopic-position-canvas'
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <Box sx={contentStyle}>
          <Box>
            <Typography sx={title} variant='h5'>
              1. How to upload a Topic's Background Image?
            </Typography>
            <Typography sx={paragraph} variant='body1'>
              1.1 Add a picture with exactly this sizes: 4000x2000 px
            </Typography>
            <Typography sx={paragraph} variant='body1'>
              1.2. When all four edges are joined together, it should form an
              sphere
            </Typography>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};
